import {
  SubmitPaymentsIdentityArgs,
  PaymentsIdentityFileModel,
  AddressModel,
} from '../types/payments-identity'

const addressToParams = (address: AddressModel | null) =>
  (address && {
    country_id: address.countryId,
    name: address.name || null,
    city: address.city || null,
    line1: address.line1 || null,
    line2: address.line2 || null,
    postal_code: address.postalCode || null,
  }) ||
  null

const documentFileToParams = (file: PaymentsIdentityFileModel) => ({
  type: file.type,
  files: file.files.map(({ identifier, body, mediaType }) => ({
    identifier,
    body,
    media_type: mediaType,
  })),
})

export const submitPaymentsIdentityArgsToParams = ({
  firstName,
  lastName,
  birthdate,
  nationality,
  ssnSerial,
  personalIdNumber,
  address,
  ubos,
  documents,
}: SubmitPaymentsIdentityArgs) => {
  const transformedDocuments: Array<{
    type: string
    files: Array<{
      identifier: string
      uuid?: string | null
      mediaType?: string | null
      body?: string | null
    }>
  }> = documents?.map(document => documentFileToParams(document)) || []

  return {
    first_name: firstName,
    last_name: lastName,
    nationality,
    birthdate,
    ssn_serial: ssnSerial,
    personal_id_number: personalIdNumber,
    address: addressToParams(address),
    ubos:
      ubos?.map(ubo => ({
        first_name: ubo.firstName,
        last_name: ubo.lastName,
        birthday: ubo.birthday,
        nationality: ubo.nationality,
        birthplace_city: ubo.birthplaceCity,
        birthplace_country: ubo.birthplaceCountry,
        address: addressToParams(ubo.address),
      })) || null,
    documents: transformedDocuments,
  }
}
